import gql from 'graphql-tag';
import { schoolFragment } from './fragments';

export const schools = gql`
  query schools($where: SchoolWhereInput, $orderBy: SchoolOrderByInput, $skip: Int, $after: String, $before: String, $first: Int, $last: Int) {
    schools(where: $where, orderBy: $orderBy, skip: $skip, after: $after, before: $before, first: $first, last: $last) ${schoolFragment}
  }
`;
